module.exports = __webpack_public_path__ + "img/Rule_box.85325dae.png";